<template>
    <div>
        <my-header :breadcrumb="breadcrumb"></my-header>
        <el-card class="box-card">
            <!--搜索-->
            <el-button type="primary" @click="dialogFormVisible=true">添加权限</el-button><el-button type="primary" @click="clickBack">返回菜单</el-button>
            <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="权限名称" :label-width="formLabelWidth">
                        <el-input v-model="form.permission_name"></el-input>
                    </el-form-item>

                    <el-form-item label="权限代码" :label-width="formLabelWidth">
                        <el-input v-model="form.permission_code" placeholder="字母、数字、减号"></el-input>
                    </el-form-item>


                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="clickAdd">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 工具栏（列表名称、列表显示项设置） -->
            <!--列表内容-->
            <el-table
                    :data="tableData"
                    style="width: 100%;margin:20px 0 0 0;"
                    row-key="id"
                    :default-sort="{prop: 'order_sort', order: 'ascending'}"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >

                <el-table-column
                        prop="permission_name"
                        label="权限名称"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="permission_code"
                        label="权限代码"
                        sortable
                >
                </el-table-column>

                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>

        </el-card>
    </div>
</template>

<script>
    import MyHeader from "../header";
    export default {
        name: "menu-permission",
        components: {MyHeader},
        data(){
            return {
                breadcrumb: [
                    {name: '菜单管理'},
                    {name: '菜单权限列表'}
                ],
                activeTab:'1',
                tableData:[],
                formInline:{},
                totalCount:0,
                dialogFormVisible:false,
                form:{},
                formLabelWidth: '120px',
                dialogTitle:'添加权限',
                menuId:0
            }
        },
        created() {
            this.menuId = this.$route.query.menuId;
            this.getList();

        },
        methods:{
            getList(){
                this.$http.get('/v1/menu-permission/list',{params:{menuId:this.menuId}}).then(({data}) => {
                    this.tableData = data.result;
                })
            },
            clickBack(){
                this.$router.back()
            },
            clickAdd(){
                this.form.menu_id = this.menuId;
                if (!this.form.id){
                    this.$http.post('/v1/menu-permission/create',this.form).then(({data})=>{
                        if (data.errcode == 0) {
                            this.$message.success(data.msg)
                            this.dialogFormVisible = false;
                            this.getList();
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }else {
                    this.$http.patch('/v1/menu-permission/update',this.form).then(({data})=>{
                        if (data.errcode == 0) {
                            this.$message.success(data.msg)
                            this.dialogFormVisible = false;
                            this.getList();
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }

            },
            handleEdit(index,row){
                this.$http.get('/v1/menu-permission/view',{params:{id:row.id}}).then(({data})=>{
                    this.form = data;
                })
                this.dialogFormVisible = true;
            },
            handleDelete(index,row){
                this.$http.delete('/v1/menu-permission/delete',{params:{id:row.id}}).then(({data})=>{
                    if (data.errcode == 0) {
                        this.$message.success(data.msg)
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .box-card{
        margin:20px;
    }
    .pages{
        text-align: right;
        margin: 20px 0 0 0;

    }
    .goods-image, .goods-image img {
        float: left;
    }

    .goods-name {
        display: inline-block;
        margin: 0 0 0 10px;
        width:290px;
    }
</style>